/**
 * 默认图层快捷工具栏：优先渲染完整替换内容，否则渲染业务自定义项和按 sort 排序的工具项。
 */
import React, { useMemo } from 'react';
import { useFramework } from '@/framework';
import { type ContextMenuPlugin } from '@/plugins/context-menu';
import { useShortcutMenuState } from '../states/shortcut-menu-state';

const DefaultShortcutList: React.FC<{ id: string }> = ({ id }) => {
    const framework = useFramework();
    const advancedAiEnabled = useShortcutMenuState()((state) => state.advancedAiEnabled);
    const items = useShortcutMenuState()((state) => state.items);
    const customItems = useShortcutMenuState()((state) => state.customItems);
    const replacementMenu = useShortcutMenuState()((state) => state.replacementMenu);
    const sortedItems = useMemo(() => [...items].sort((a, b) => a.sort - b.sort), [items]);
    const layer = framework.service.flatLayer.getLayer(id);
    const activePickLayer = framework.service.frame.getActivePickLayer();

    if (!layer) return null;

    const getContextMenu = () => {
        const instance = framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin');
        if (!instance) {
            throw new Error('ContextMenuPlugin is not found');
        }
        return instance;
    };

    if (replacementMenu) {
        return (
            <div className="shortcut-menu" onMouseDown={(event) => event.stopPropagation()}>
                {replacementMenu}
            </div>
        );
    }

    const renderArgs = {
        id,
        framework,
        layer,
        activePickLayer,
        advancedAiEnabled,
    };

    return (
        <div
            className="shortcut-menu"
            onMouseDown={(event) => {
                event.stopPropagation();
                getContextMenu().close();
            }}
        >
            {customItems
                .filter((item) => item.layerType === activePickLayer?.layerType)
                .map((item) => (
                    <React.Fragment key={item.key}>{item.node}</React.Fragment>
                ))}
            {sortedItems.map((item) => (
                <React.Fragment key={item.key}>{item.render(renderArgs)}</React.Fragment>
            ))}
        </div>
    );
};

export default DefaultShortcutList;
